<template lang="pug">
el-dialog.modal-inibir-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='30%'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-inibir-restricoes__header
                .modal-inibir-restricoes__header--icon
                    i.el-icon-warning-outline
                .modal-inibir-restricoes__header--title
                    | Inibir restrições

        section.modal-inibir-restricoes__body
            .modal-inibir-restricoes__body--descricao
                div(v-html='identificarLabelRestricoes()')

                .modal-inibir-restricoes__body--form
                    el-form(
                        label-position='top',
                        ref='formInibirRestricoes',
                        :model='payload',
                        :rules='formRules'
                    )
                        el-form-item(
                            prop='operacoes',
                            v-if='this.operacoes.length > 0'
                        )
                            template(slot='label')
                                span.label Selecionar operações
                            el-checkbox(
                                v-model='selecionarTodas',
                                @change='alterarCheckbox()'
                            ) Selecionar todas
                            el-select.w-100(
                                v-model='payload.restricaoOperacao[0].idsOperacoes',
                                :loading='carregandoOperacoes',
                                multiple,
                                filterable,
                                collapse-tags,
                                placeholder='Clique para selecionar',
                                value-key='id',
                                @change='verificarCheckbox()'
                            )
                                el-option(
                                    v-for='operacao in operacoes',
                                    :key='operacao.id',
                                    :label='montarLabelOpcoes(operacao)',
                                    :value='operacao.id'
                                )

                        el-form-item(prop='justificativa')
                            template(slot='label')
                                span.label.campo_obrigatorio Selecione a justificativa
                            el-select.w-100(
                                v-model='payload.idJustificativa',
                                placeholder='Clique para selecionar',
                                value-key='id'
                            )
                                el-option(
                                    v-for='justificativa in justificativas',
                                    :key='justificativa.id',
                                    :label='justificativa.nome',
                                    :value='justificativa.id'
                                )

                        el-form-item(prop='descricao')
                            template(slot='label')
                                span.label Descrição

                            el-input(
                                v-model='payload.descricaoJustificativa',
                                type='textarea',
                                :rows='3',
                                placeholder='Digite aqui sua justificativa...'
                            )

        section.modal-inibir-restricoes__action
            BaseButton(size='mini', @click='fechar')
                | Voltar
            BaseButton(type='primary', size='mini', @click='inibirRestricao')
                | Continuar
</template>

<script>
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import DiagnosticoSociambientealRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInibirRestricoesCdaWa',

    components: {
        DiagnosticoSociambientealRepresentante,
        BaseButton
    },

    emits: ['atualizar-restricao-inibido'],

    props: {
        idOperacao: {
            required: true
        },
        codigoCamada: {
            type: String,
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            carregandoOperacoes: false,
            mostrarDialog: false,
            selecionarTodas: false,
            payload: {
                codigoCamada: null,
                idJustificativa: null,
                descricaoJustificativa: null,
                acao: 'INSERIR',
                restricaoOperacao: [
                    {
                        idsOperacoes: [],
                        codigoRestricao: null
                    }
                ]
            },
            formRules: {
                justificativa: [
                    { validator: this.checkRuleJustificativa, trigger: 'blur' }
                ],
                descricao: [
                    { validator: this.checkRuleDescricao, trigger: 'blur' }
                ]
            },
            operacoes: [],
            justificativas: []
        };
    },

    watch: {
        mostrarDialog: function (value) {
            if (value) {
                this.payload.codigoCamada = this.codigoCamada;
                this.payload.restricaoOperacao[0].codigoRestricao =
                    this.codigoRestricao;
                this.buscarOperacoesInibicao();
                this.buscarJustificativas();
            }
        }
    },

    methods: {
        async buscarOperacoesInibicao() {
            this.carregandoOperacoes = true;
            await OperacaoCdaWaService.buscarOperacoesInibicao(
                {
                    idOperacao: this.idOperacao,
                    codigoRestricao: this.codigoRestricao,
                    acao: 'INSERIR'
                },
                true
            )
                .then(({ data }) => {
                    this.operacoes = data.itens;
                    this.carregandoOperacoes = false;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar as operações para inibição'
                    })
                )
                .finally(() => {
                    this.carregandoOperacoes = false;
                });
        },
        alterarCheckbox() {
            this.payload.restricaoOperacao[0].idsOperacoes = [];
            if (this.selecionarTodas) {
                this.operacoes.forEach(operacao => {
                    this.payload.restricaoOperacao[0].idsOperacoes.push(
                        operacao.id
                    );
                });
            }
        },
        verificarCheckbox() {
            if (
                this.payload.restricaoOperacao[0].idsOperacoes.length ===
                this.operacoes.length
            ) {
                this.selecionarTodas = true;
            } else {
                this.selecionarTodas = false;
            }
        },
        async buscarJustificativas() {
            await OperacaoCdaWaService.buscarJustificativasInibirRestricoes()
                .then(({ data }) => {
                    this.justificativas = data.itens;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar as justificativas para inibição'
                    })
                );
        },
        checkRuleJustificativa(rule, value, callback) {
            if (this.payload.idJustificativa === null) {
                return callback(
                    new Error('Escolha pelo menos uma justificativa')
                );
            }
            callback();
        },
        checkRuleDescricao(rule, value, callback) {
            if (this.payload.descricaoJustificativa?.length > 1000) {
                return callback(
                    new Error('Descrição muito longa. Máximo 1000 caracteres')
                );
            }
            callback();
        },
        async inibirRestricao() {
            const formValidado = await this.$refs.formInibirRestricoes
                .validate()
                .then(value => value)
                .catch(() => false);

            if (!formValidado) return;

            if (this.payload.restricaoOperacao[0].idsOperacoes.length === 0) {
                this.payload.restricaoOperacao[0].idsOperacoes.push(
                    this.idOperacao
                );
            }
            await OperacaoCdaWaService.inibirRestricao(this.payload)
                .then(({ data }) => {
                    this.$notify.success({
                        message: data,
                        duration: 10000
                    });
                    this.fechar();
                    this.$emit('atualizar-restricao-inibido');
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível inibir a restrição. ' +
                            'Se o problema persistir, entre em contato com suporte.'
                    });
                    this.fechar();
                })
                .finally(() => {
                    this.payload = {
                        codigoCamada: null,
                        idJustificativa: null,
                        descricaoJustificativa: null,
                        acao: 'INSERIR',
                        restricaoOperacao: [
                            {
                                idsOperacoes: [],
                                codigoRestricao: null
                            }
                        ]
                    };
                });
        },
        identificarLabelRestricoes() {
            if (this.operacoes.length > 0) {
                return `<span>Você está prestes a inibir esta restrição! Ela também se encontra presente
                em ${this.operacoes.length} operação(ões) e você também pode inibi-las diretamente daqui.
                Siga as etapas para continuar.</span>`;
            } else {
                return '<span>Você está prestes a inibir esta restrição. Siga as etapas para continuar.</span>';
            }
        },
        montarLabelOpcoes(operacao) {
            return (
                'ID: ' +
                operacao.identificador +
                ' | Nome: ' +
                (operacao.nome ? operacao.nome : '--')
            );
        },
        fechar() {
            this.selecionarTodas = false;
            this.mostrarDialog = false;
            this.payload = {
                codigoCamada: null,
                idJustificativa: null,
                descricaoJustificativa: null,
                acao: 'INSERIR',
                restricaoOperacao: [
                    {
                        idsOperacoes: [],
                        codigoRestricao: null
                    }
                ]
            };
        }
    }
};
</script>

<style lang="scss">
.modal-inibir-restricoes {
    display: flex;

    .modal-inibir-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-inibir-restricoes__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-inibir-restricoes__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-inibir-restricoes__body {
        width: 100%;

        .modal-inibir-restricoes__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }
    }

    .modal-inibir-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .campo_obrigatorio::after {
        content: '*';
        color: red;
    }
}
</style>
